import { createSlice } from "@reduxjs/toolkit";

const initialState = null;

const accordiFiltersSlice = createSlice({
  name: "accordiFilters",
  initialState,
  reducers: {
    setAccordiFilters: (state, action) => action.payload,
    clearAccordiFilters: () => null,
  },
});

export const { setAccordiFilters, clearAccordiFilters } =
  accordiFiltersSlice.actions;
export default accordiFiltersSlice.reducer;
